export enum RoundTypeEnum {
  Sport = 'SPORT',
  Other = 'OTHER',
  VideoStreak = 'VIDEO_STREAK',
  Streak = "Streak"
}
